export function useIsSelenium() {
  return document.cookie.includes('hs_selenium');
}